'use client';

import { Suspense } from 'react';

import { ProfileForm } from '@eliadmin/core/src/components/nt/account/profile/profile-form';
import { AccountHeading } from '@eliadmin/core/src/components/nt/account/shell/account-card';
import {
  useAccountTexts,
  useCheckoutTexts,
} from '@eliadmin/core/src/components/nt/shared/site-texts';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

/**
 * „Môj profil“ (Figma 205:11129): the heading, then the profile form 16 px below (24 px with the
 * heading's padding). The address and company labels are checkout texts („Ulica a číslo domu“,
 * „Firma / podnikateľ“ …) – the profile layout provides them. The form waits for the countries.
 */
export function ProfileView() {
  const { t } = useTranslations();
  const texts = useAccountTexts();
  const checkoutTexts = useCheckoutTexts();
  const me = useCustomerStore(s => s.me);
  if (!me) return null;

  return (
    <div className="flex flex-col gap-4">
      <AccountHeading title={t('text1134')} text={texts.profileText} />
      <Suspense fallback={<GenericLoader />}>
        <ProfileForm
          key={me.customer.id}
          customer={me.customer}
          authToken={me.authToken}
          checkoutTexts={checkoutTexts}
        />
      </Suspense>
    </div>
  );
}
